<script>

    import { createEventDispatcher } from 'svelte'
    import { replace } from 'svelte-spa-router'
    import { QuotationStore } from '../stores'

    import NumeralMethods from '../$methods/numeral.methods'

    import Button from '../$components/button.svelte'
    import Value from '../$components/value.svelte'
    import Table from '../$components/table.svelte'

    const dispatch = createEventDispatcher()

    export let quotation = null

</script>

<div class="title is-3">Precios</div>
<hr>
{#if !quotation}
    <Table items={ $QuotationStore.services.length }>
        <thead>
            <tr>
                <th>#</th>
                <th>Proveedor</th>
                <th>Servicio</th>
                <th>Precio</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            {#each $QuotationStore.services as service, index}
                <tr>
                    <td>{ index+1 }</td>
                    <td>{ service.provider }</td>
                    <td>{ service.service }</td>
                    <td>{ NumeralMethods.cash(service.finalPrice) }</td>
                    <td>
                        <Button on:click={() => dispatch('selected', service)} text="Continuar" icon="arrow-alt-circle-right" color="primary" size="small" />
                    </td>
                </tr>
            {/each}
        </tbody>
    </Table>
    <br>
    <div class="columns">
        <div class="column">
            <Value label="Origen" value={ $QuotationStore.pickup.state } />
        </div>
        <div class="column">
            <Value label="Destino" value={ $QuotationStore.delivery.state } />
        </div>
        <div class="column">
            <Value label="Distancia" value={ $QuotationStore.distance.kilometres } postfix="KM" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Paquete" value={ `${ $QuotationStore.package.width }CM, ${ $QuotationStore.package.height }CM, ${ $QuotationStore.package.height }CM, ${ $QuotationStore.package.weight }KG` } />
        </div>
        <div class="column">
            <Value label="Volumétrico" value={ $QuotationStore.package.volumetric } postfix="KG" />
        </div>
        {#if $QuotationStore.package.value}
            <div class="column">
                <Value label="Seguro" value={ NumeralMethods.cash($QuotationStore.package.value) } />
            </div>
        {:else}
            <div class="column">
                <Value label="Seguro" value={ $QuotationStore.package.value? 'SI' : 'NO' } />
            </div>
        {/if}
    </div>
    <div class="columns">
        <div class="column">
            <div class="items end">
                <Button on:click={() => dispatch('step', 'main')} text="Regresar" icon="chevron-left" />
            </div>
        </div>
    </div>
{:else}
    <Table items={ $QuotationStore.services.length }>
        <tbody>
            {#each $QuotationStore.services as service, index}
                <tr>
                    <td>{ index+1 }</td>
                    <td>{ service.provider }</td>
                    <td>{ service.service }</td>
                    <td>{ NumeralMethods.cash(service.finalPrice) }</td>
                    <td>
                        <Button on:click={() => dispatch('selected', service)} text="Continuar" icon="arrow-alt-circle-right" color="primary" size="small" />
                    </td>
                </tr>
            {/each}
        </tbody>
    </Table>
    <br>
    <div class="columns">
        <div class="column">
            <Value label="Origen" value={ quotation.pickup.state } />
        </div>
        <div class="column">
            <Value label="Destino" value={ quotation.delivery.state } />
        </div>
        <div class="column">
            <Value label="Distancia" value={ quotation.distance.kilometres } postfix="KM" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Paquete" value={ `${ quotation.package.width }CM, ${ quotation.package.height }CM, ${ quotation.package.height }CM, ${ quotation.package.weight }KG` } />
        </div>
        <div class="column">
            <Value label="Volumétrico" value={ quotation.package.volumetric } postfix="KG" />
        </div>
        {#if quotation.package.value}
            <div class="column">
                <Value label="Seguro" value={ NumeralMethods.cash(quotation.package.value) } />
            </div>
        {:else}
            <div class="column">
                <Value label="Seguro" value={ quotation.package.value? 'SI' : 'NO' } />
            </div>
        {/if}
    </div>
    <div class="columns">
        <div class="column">
            <div class="buttons">
                <Button on:click={() => dispatch('step', 'main')} text="Cotizar de nuevo" icon="chevron-left" fullwidth />
                <Button on:click={() => replace('#/signup')} text="Registrarme" icon="star" color="primary" fullwidth />
            </div>
        </div>
    </div>
{/if}
